// removed by extract-text-webpack-plugin
module.exports = {"link":"_3fuq8wZXlMOIrcoGvJPL5z","container":"_24fEWHly2WoWIF9m9WLLZm","image":"_3YVgK01pewsfLaYHwxEPEX","detail":"-tg_DTFcIsD0dCk5IOW2L","profile-pic":"GjvnmueNOgKKposFuHJzW","user-name":"rQxFiRnjvF3Z5JMUXBBqn","desc-wrapper":"_2QOpMWryjrYNPS6cwfzibI","open":"_2AtkqQoEYkG6nIPSDAuRRk","close":"_3hl8SqTAvXvnZzhrYwI7Pu","review-content":"_2m38FV7tB8onycSMh9lRX5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/ReviewItem.scss
// module id = 1173
// module chunks = 47